import axios, { AxiosPromise } from 'axios';

import apiPaths from 'enums/apiPaths';

export interface IPruvodceVYPIS {
    mtgid?: string;
    isin?: string;
    lei?: string;
    rozhodnyden?: string;
    meznidatum?: string;
    datumzverejneni?: string;
    leiprijemce?: string;
    bic?: string;
    jmeno?: string;
    ulice?: string;
    mesto?: string;
    psc?: string;
    stat?: string;
    email?: string;
    url?: string;
}

export const pruvodceVYPISGETApi = (id: number): AxiosPromise<IPruvodceVYPIS> => {
    return axios({
        method: 'GET',
        url: `SRD/${id}${apiPaths.PRUVODCE_VYPIS}`
    });
};

export const pruvodceVYPISPUTApi = (id: number, data: IPruvodceVYPIS): AxiosPromise<IPruvodceVYPIS> => {
    return axios({
        method: 'PUT',
        url: `SRD/${id}${apiPaths.PRUVODCE_VYPIS}`,
        data: {
            ...data
        }
    });
};

export const pruvodceVYPISPOSTApi = (
    id: number,
    data: IPruvodceVYPIS
): AxiosPromise<{ datum: string; upozor: { typ: string }[] }> => {
    return axios({
        method: 'POST',
        url: `SRD/${id}${apiPaths.PRUVODCE_VYPIS}`,
        data: {
            ...data
        }
    });
};

export const pruvodceVYPIScertApi = (
    id: number,
    data: IPruvodceVYPIS
): AxiosPromise<{ datum: string; upozor: { typ: string }[] }> => {
    return axios({
        method: 'POST',
        url: `SRD/pruvodceVYPIS/Cert/${id}`,
        data: {
            ...data
        }
    });
};
